import React from 'react';
import ReactEcharts from 'echarts-for-react';
import _ from "lodash";
import PropTypes from 'prop-types';
import { getYAxisIndex } from './Helpers.js';

const LineBarChart = (props) => {
  const { 
    // Bar layout
    areaChart = false,
    barWidth,
    borderRadius = [0, 0, 0, 0],
    spaceBottom = '15%',
    spaceLeft = '4%',
    spaceRight = '2%',
    spaceTop = '10%',

    // color
    color = [],

    // Data
    data = [],

    // Events
    events = false,
    onChartClick = null,

    // Legend configuration
    legend = [],
    legendShow = true,
    legendSelectMode = true,

    // Tooltip
    toolTipConfig = null,

    // Axis configuration
    xAxisData = [],
    xField = '',
    y1Field = '',
    yField = '',
    ynamegap = 40,
    axisTickShow = false,

   } = props;
   
  const getSeriesData = () => {
    const seriesData = [];
  
    if (data.length > 0) {
      data.map((item,index) => {
        const seriesColor = color ? color[index] : '';
        seriesData.push({
          name: data[index].name,
          type: data[index].type,
          itemStyle: {
            color: seriesColor,
            borderRadius:borderRadius,
          },
          barWidth:barWidth?barWidth: undefined,
          yAxisIndex: data[index].type === "line" ? 1 : 0,
          z:  data[index].type === "line" ? 2 : 4,
          areaStyle: data[index].type === "line" && areaChart ? 
          {
            opacity: 100,
            color: 'rgb(255 127 127 / 36%)',
          } : null,
          
          tooltip: {
            // formatter:function(params){
            //   return params.value +" "+ (tooltipLable ? tooltipLable[params.dataIndex] : "");
            // },
            valueFormatter: function (value,index) {
              return value;
            }
          },
          data: data[index].data
        });
        
      });
    }
    return seriesData;
  };
  const option = {
    tooltip: toolTipConfig ? { ...toolTipConfig } : {
      show: true,
      trigger: 'item',

  },
    toolbox: {
      feature: {
        show: false
      }
    },
    grid: {
      top: spaceTop,  
      left: spaceLeft,
      right: spaceRight,
      bottom: spaceBottom,
      containLabel: true,
    },
    legend: {
      data: legend,
      icon: 'circle',
      show: legendShow,
      type: 'scroll',
      orient: "horizontal",
      left: 'left',
      selectedMode: legendSelectMode,
    },
    xAxis: [
      {
        type: 'category',
        data: xAxisData,
        axisPointer: {
            show: false
        },
        axisTick: {
          show: axisTickShow,
        },
        name: xField,
        nameLocation: 'middle',
        nameGap:30,
      }
    ],
    yAxis: [
      {
        ...getYAxisIndex(),
        type: 'value',
        name: yField,
        nameLocation: 'middle',
        nameGap:ynamegap,
      },
      {
        type: 'value',
        name: y1Field,
        nameLocation: 'middle',
        nameGap:ynamegap,

      }
    ],
    series: getSeriesData()
  };

  const handleChartClick = (params) => {
    if (onChartClick) {
      onChartClick(params);
    }
  };
  const onEvents = {
    'click': handleChartClick, // chart click event
};
  return <ReactEcharts option={option} onEvents={events ? onEvents : ""}/>;
};


function areEqual(prevProps, nextProps) {
  if(_.isEqual(prevProps.data, nextProps.data) &&
  _.isEqual(prevProps.xAxisData, nextProps.xAxisData) &&
  _.isEqual(prevProps.yField, nextProps.yField) &&
  _.isEqual(prevProps.xField, nextProps.xField) &&
  _.isEqual(prevProps.ynamegap, nextProps.ynamegap) &&
  _.isEqual(prevProps.xnamegap, nextProps.xnamegap) &&
  _.isEqual(prevProps.spaceTop, nextProps.spaceTop) &&
  _.isEqual(prevProps.spaceLeft, nextProps.spaceLeft) &&
  _.isEqual(prevProps.spaceRight, nextProps.spaceRight) &&
  _.isEqual(prevProps.color, nextProps.color) &&
  _.isEqual(prevProps.isScrollEndLimit, nextProps.isScrollEndLimit) &&
  _.isEqual(prevProps.isScrollStartLimit, nextProps.isScrollStartLimit) &&
  _.isEqual(prevProps.legend, nextProps.legend) &&
  _.isEqual(prevProps.spaceBottom, nextProps.spaceBottom) &&
  _.isEqual(prevProps.chartTitle, nextProps.chartTitle) &&
  _.isEqual(prevProps.xAxisConfig, nextProps.xAxisConfig) &&
  _.isEqual(prevProps.yAxisConfig, nextProps.yAxisConfig) &&
  _.isEqual(prevProps.yAxisSpace, nextProps.yAxisSpace) &&
  _.isEqual(prevProps.legendSelectMode, nextProps.legendSelectMode) &&
  _.isEqual(prevProps.showLegend, nextProps.showLegend)) {
    return true;
  } else {
    return false;
  }
}
LineBarChart.propTypes = {
  areaChart: PropTypes.bool,
  axisTickShow: PropTypes.bool,
  barWidth: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  borderRadius: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  color: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
      data: PropTypes.array,
    })
  ),
  events: PropTypes.bool,
  legend: PropTypes.arrayOf(PropTypes.string),
  legendShow: PropTypes.bool,
  legendSelectMode: PropTypes.bool,
  onChartClick: PropTypes.func,
  spaceBottom: PropTypes.string,
  spaceLeft: PropTypes.string,
  spaceRight: PropTypes.string,
  spaceTop: PropTypes.string,
  toolTipConfig: PropTypes.object,
  xAxisData: PropTypes.array,
  xField: PropTypes.string,
  y1Field: PropTypes.string,
  yField: PropTypes.string,
  ynamegap: PropTypes.number,
};
export default React.memo(LineBarChart, areEqual);



